import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  environment: 'preprod',
  action: 'getAllCustomers',
  companyId: 1001,
  instanceId: '',
  queryParams: '',
  disputeId: '',
  body: '',
};

export default defaults;
